function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
  fill: "#F0F0F0"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0-4.76-2.765-8.858-6.78-10.807v21.602A11.967 11.967 0 0024 12z",
  fill: "#D80027"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M.011 12c0 4.76 2.764 8.858 6.78 10.807V1.193C2.775 3.142.01 7.24.01 12zM8.87 12A3.135 3.135 0 0012 15.13 3.135 3.135 0 0015.128 12v-1.04h-6.26V12z",
  fill: "#6DA544"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.18 9.91h-3.13a1.04 1.04 0 00-1.038-1.04 1.04 1.04 0 00-1.04 1.04h-3.13c0 .578.496 1.039 1.075 1.039h-.035c0 .579.472 1.04 1.039 1.04 0 .578.473 1.039 1.04 1.039h2.09a1.04 1.04 0 001.04-1.04 1.04 1.04 0 001.039-1.04h-.036c.579.013 1.087-.46 1.087-1.038z",
  fill: "#FF9811"
});
function SvgFlagMx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "/img/flag_mx.svg";
export { SvgFlagMx as ReactComponent };